var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5.93699C13.3626 5.71497 14 4.93192 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 9.99999 2.89543 9.99999 4C9.99999 4.93192 10.6374 5.71497 11.5 5.93699V8.03103C9.6906 8.25666 8.2565 9.69077 8.03091 11.5002H5.93708C5.71518 10.6374 4.93205 9.99982 4 9.99982C2.89543 9.99982 2 10.8953 2 11.9998C2 13.1044 2.89543 13.9998 4 13.9998C4.93179 13.9998 5.71476 13.3626 5.9369 12.5002H8.03094C8.2566 14.3095 9.69065 15.7435 11.5 15.9691V18.0631C10.6374 18.2851 9.99999 19.0682 9.99999 20.0001C9.99999 21.1047 10.8954 22.0001 12 22.0001C13.1046 22.0001 14 21.1047 14 20.0001C14 19.0682 13.3626 18.2851 12.5 18.0631V15.9691C14.3093 15.7435 15.7434 14.3095 15.969 12.5002H18.0631C18.2852 13.3626 19.0682 13.9998 20 13.9998C21.1045 13.9998 22 13.1044 22 11.9998C22 10.8953 21.1045 9.99982 20 9.99982C19.0679 9.99982 18.2848 10.6374 18.0629 11.5002H15.969C15.7435 9.69078 14.3094 8.25667 12.5 8.03104V5.93699Z",
    fill: "#C2D1FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.d05271edf3bf53b14b7b88df52583543.svg";
export { ForwardRef as ReactComponent };